import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, filter, take, takeUntil } from 'rxjs';

import { ClientService } from './services/client.service';
import { CLASS_TYPE_ROUTES } from './utils/utils';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'sketchplay-marketing-web';

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private clientService: ClientService,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.resolveTypelessRegistrationLink());
  }

  /**
   * Registration links generated before the event type was added to the URL land on the root
   * (/?eventId=&orgId=), which redirects to /home and drops the params, so nothing opens. Those
   * links are already printed on QR codes and cannot be regenerated, so resolve the event here
   * and forward to its own page, which loads it and opens the registration drawer.
   */
  private resolveTypelessRegistrationLink(): void {
    const tree = this.router.parseUrl(this.router.url);
    const path = (tree.root.children['primary']?.segments ?? [])
      .map((segment) => segment.path)
      .join('/');
    if (path !== '' && path !== 'home') {
      return;
    }

    const { eventId, orgId } = tree.queryParams;
    if (!eventId || !orgId) {
      return;
    }

    this.clientService
      .getEventById(eventId, orgId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const route = CLASS_TYPE_ROUTES[response?.data?.classType];
          if (response?.status && route) {
            this.router.navigate([`/${route}`], {
              queryParams: tree.queryParams,
              replaceUrl: true,
            });
          }
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
